/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './CurrentRequiredMinimumDistributionCard.scss';

import moment from 'moment';
import React from 'react';

import BaseCard from 'components/shared/Card/BaseCard';
import Content from 'services/Content';
import { YEAR_DISPLAY_FORMAT } from 'services/Dates';
import { requiredMinimumDistributionUrl } from 'services/Externals';

const CurrentRequiredMinimumDistributionCard = ({
  isVisible,
  isLoading,
  hasError
}) => {
  const footer = (
    <a
      href={requiredMinimumDistributionUrl()}
      className="card-action-link"
      rel="noopener noreferrer"
      id="view-rmds-link">
      View RMDs
    </a>
  );

  if (!isVisible || isLoading || hasError) {
    return null;
  }

  return (
    <BaseCard
      isLoading={isLoading}
      title="Required Minimum Distribution"
      footer={footer}
      className="standard current-required-minimum-distribution-card-container">
      <div className="current-required-minimum-distribution-card">
        <p className="current-required-minimum-distribution-card-heading">
          {moment.utc().format(YEAR_DISPLAY_FORMAT)} Required Minimum
          Distribution (RMD)
        </p>
        <div className="current-required-minimum-distribution-card-content">
          {Content.currentRequiredMinimumDistribution}
        </div>
      </div>
    </BaseCard>
  );
};

CurrentRequiredMinimumDistributionCard.defaultProps = {
  isLoading: false,
  hasError: false
};

export default CurrentRequiredMinimumDistributionCard;
